export function Skeleton({
  w, h, r,
}: {
  w?: string | number;
  h?: number;
  r?: number;
}) {
  return (
    <div
      className="skeleton"
      style={{
        width: w ?? "100%",
        height: h ?? 12,
        borderRadius: r ?? 6,
      }}
    />
  );
}

export function MetricSkeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <Skeleton w={72} h={10} />
      <Skeleton w={110} h={26} />
      <Skeleton w={86} h={12} />
    </div>
  );
}

export function ChartSkeleton() {
  const bars = [40, 70, 55, 90, 48, 76, 62, 84, 50, 68];
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 120, padding: "8px 0" }}>
      {bars.map((height, i) => (
        <Skeleton key={i} w="100%" h={height} r={3} />
      ))}
    </div>
  );
}

export function BarsSkeleton() {
  const widths = [88, 70, 54, 40, 28];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
      {widths.map((width, i) => (
        <div key={i} style={{ display: "grid", gridTemplateColumns: "118px minmax(0,1fr) 76px", gap: 12, alignItems: "center" }}>
          <Skeleton w={90} h={12} />
          <Skeleton w={`${width}%`} h={9} r={3} />
          <Skeleton w={48} h={12} />
        </div>
      ))}
    </div>
  );
}

export function FunnelSkeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {[100, 78, 56, 34].map((width, i) => (
        <Skeleton key={i} w={`${width}%`} h={28} r={6} />
      ))}
    </div>
  );
}

/** First-paint stand-in for the built-in Overview while /portfolio is in flight. */
export function OverviewSkeleton() {
  return (
    <div className="page" style={{ paddingTop: 26 }}>
      <div className="skeleton-overview-metrics">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="panel wpanel"><MetricSkeleton /></div>
        ))}
      </div>
      <div className="panel" style={{ marginTop: 14, minHeight: 160 }}>
        <Skeleton w={120} h={10} />
        <div style={{ marginTop: 18 }}><BarsSkeleton /></div>
      </div>
      <div className="panel" style={{ marginTop: 14, minHeight: 200 }}>
        <Skeleton w={110} h={10} />
        <div style={{ marginTop: 18 }}><ChartSkeleton /></div>
      </div>
      <div className="skeleton-overview-split">
        <div className="panel">
          <Skeleton w={70} h={10} />
          <div style={{ marginTop: 18 }}><FunnelSkeleton /></div>
        </div>
        <div className="panel">
          <Skeleton w={150} h={10} />
          <div style={{ marginTop: 18 }}><BarsSkeleton /></div>
        </div>
      </div>
    </div>
  );
}
